<template>
    <div class="content">
        <div class="rsk-p-xl">
            <div class="rsk-form-control">
                <h2 class="rsk-page-title rsk-mb-s">テスト解答内容</h2>
            </div>
            <div class="rsk-panel rsk-mb-m">
                <div class="rsk-divider rsk-divider--horizontal rsk-mt-s rsk-mb-s"></div>
                <div class="rsk-form-control rsk-form-control--top">
                    <div class="rsk-flex rsk-justify-between">
                        <div class="rsk-form-control__label">テスト名</div>
                    </div>
                    <div v-text="detail.testName" class="rsk-form rsk-form--expand rsk-text-gray060"></div>
                </div>
                <div class="rsk-divider rsk-divider--horizontal rsk-mt-s rsk-mb-s"></div>
                <div class="rsk-form-control rsk-form-control--top">
                    <div class="rsk-flex rsk-justify-between">
                        <div class="rsk-form-control__label">ボックス名</div>
                    </div>
                    <div v-text="detail.lessonName" class="rsk-form rsk-form--expand rsk-text-gray060"></div>
                </div>
                <div class="rsk-divider rsk-divider--horizontal rsk-mt-s rsk-mb-s"></div>
                <div class="rsk-form-control rsk-form-control--top">
                    <div class="rsk-flex rsk-justify-between">
                        <div class="rsk-form-control__label">受験日</div>
                    </div>
                    <div v-text="detail.answerBeginTm" class="rsk-form rsk-form--expand rsk-text-gray060"></div>
                </div>
                <div class="rsk-divider rsk-divider--horizontal rsk-mt-s rsk-mb-s"></div>
                <div class="rsk-form-control rsk-form-control--top">
                    <div class="rsk-flex rsk-justify-between">
                        <div class="rsk-form-control__label">合格問題数</div>
                    </div>
                    <div v-text="detail.passScore" class="rsk-form rsk-form--expand rsk-text-gray060"></div>
                </div>
                <div class="rsk-divider rsk-divider--horizontal rsk-mt-s rsk-mb-s"></div>
                <div class="rsk-form-control rsk-form-control--top">
                <div class="rsk-flex rsk-justify-between">
                        <div class="rsk-form-control__label">正解問題数</div>
                    </div>
                    <div v-text="detail.correctNum" class="rsk-form rsk-form--expand rsk-text-gray060"></div>
                </div>
                <div class="rsk-divider rsk-divider--horizontal rsk-mt-s rsk-mb-s"></div> 
                <div class="rsk-form-control rsk-form-control--top">
                    <div class="rsk-flex rsk-justify-between">
                        <div class="rsk-form-control__label">結果</div>
                    </div>
                    <div v-text="detail.testResultStr" class="rsk-form rsk-form--expand rsk-text-gray060"></div>
                </div>
                <div class="rsk-divider rsk-divider--horizontal rsk-mt-s rsk-mb-s"></div>                                                                                  
            </div>
            <table class="rsk-table rsk-mb-l" id="rsk-table" v-if="list.length > 0">
                <thead class="rsk-table__thead">
                    <tr class="rsk-table__tr">
                        <th class="rsk-table__th rsk-table__th--xs">
                            <div class="rsk-table__th-content-center">正誤</div>
                        </th>                           
                        <th class="rsk-table__th rsk-table__th--xs">
                            <div class="rsk-table__th-content-center">出題順</div>
                        </th>
                        <th class="rsk-table__th rsk-table__th--expand">
                            <div class="rsk-table__th-content-center ">問題</div>
                        </th>                        
                    </tr>
                </thead>
                <tbody class="rsk-table__tbody">               
                    <tr class="rsk-table__tr" v-for="(item, index) in list" :key="index">
                        <td class="rsk-table__td">
                            <div class="rsk-table__td-content rsk-table__td-content-center rsk-text-green" v-if="item.passScore == 0">○</div>
                            <div class="rsk-table__td-content rsk-table__td-content-center rsk-text-red" v-if="item.passScore == 1">×</div>
                        </td>
                        <td class="rsk-table__td">
                            <div class="rsk-table__td-content">
                            問題{{ index + 1 }}
                            </div>
                        </td>
                        <td class="rsk-table__td" v-if="item.questionType == 1">
                            <div class="table__td-content rsk-img-container rsk-mt-s rsk-block whiteSpace ck-content" v-dompurify-html="item.questionName"></div>
                            <div class="table__td-content text-wrap" v-for="(item2, index2) in item.detailList" :key="index2">
                                <div class="rsk-radio">
                                    <label class="rsk-radio--label">
                                        <input type="radio" :checked="item.radionAnswer === item2.detailId" class="rsk-radio__input" disabled="disabled" />
                                        <span class="rsk-radio__text">
                                            <span class="select-wrap" v-if="item.radionAnswer === item2.detailId"><b>{{ item2.selection }}</b></span>
                                            <span class="select-wrap" v-else>{{ item2.selection }}</span>
                                        </span>
                                    </label>
                                </div>
                            </div>
                        </td>
                        <td class="rsk-table__td" v-if="item.questionType == 2">
                            <div class="table__td-content rsk-img-container rsk-mt-s rsk-block whiteSpace ck-content" v-dompurify-html="item.questionName"></div>
                            <div class="table__td-content text-wrap" v-for="(item2, index2) in item.detailList" :key="index2">
                                <div class="rsk-checkbox-container">
                                    <input class="rsk-checkbox"  type="checkbox" disabled="disabled" :id="'list[' + index + '].detailList[' + index2 + ']'"  :checked="item2.check" />
                                    <label class="rsk-checkbox__image" :for="'list[' + index + '].detailList[' + index2 + ']'"></label>
                                    <label :for="'list[' + index + '].detailList[' + index2 + ']'" class="rsk-checkbox__label rsk-text-gray060">
                                        {{ item2.selection }}
                                    </label>
                                </div>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div class="rsk-p-s">
                <button @click="index" class="rsk-button rsk-button--text-user-primary">
                    <span class="rsk-button__icon-wrapper rsk-button__icon-wrapper--with-text">
                        <span class="rsk-icon rsk-carret-left-admin-primary"></span>
                    </span>
                    戻る
                </button> 
            </div>
        </div>
    </div>
</template>
<script>
import { ref, onBeforeMount, inject, onBeforeUnmount } from 'vue';
import { useRoute,useRouter } from 'vue-router'
import { dateFtt } from '@/utils/common'
import { useStore } from 'vuex'
export default {
    setup() {
        const detail = ref({});
        const list = ref([]);
        const route = useRoute();
        const router = useRouter();
        let tempList = ref([]);
        const store = useStore();
        let id = "";
        let lessonId = "";
        let goUrl = "tes"
        onBeforeMount(() => {
            if(typeof(route.params.id) != "undefined") {
                id = route.params.id;
                localStorage.testLessonId = id;
            } else {
                id = localStorage.testLessonId
            }
            if(!id) {
                router.push({ name: 'tes'});
                return;
            }

            store.commit('setCourseId', id);
        
            if (route.params.list) {
                tempList.value = JSON.parse(route.params.list);
            }

            if(typeof(route.params.fromUrl) != "undefined") {
                goUrl = route.params.fromUrl;
            }
            if(typeof(route.params.lessonId) != "undefined") {
                lessonId = route.params.lessonId;
            }
            getTestConfirmDetail()
        })
        
        const service = inject("service");

        function getTestConfirmDetail() {
            service.test.getTestConfirm(store?.getters?.getCourseId, tempList.value).then(res => {
                detail.value = res.model
                detail.value.answerBeginTm = dateFtt('yyyy/MM/dd', detail.value.answerBeginTm);
            
                list.value = res.questionList;   
            })
        }

        function index() {
            router.push({ 
                name: goUrl,
                params: {
                    research : true,
                    lessonId : lessonId
                }
            });
        }

        function setCourseId() {
            localStorage.testLessonId = store?.getters?.getCourseId; 
        }

        onBeforeUnmount(() => {
            window.removeEventListener('beforeunload', setCourseId)
        })

        window.addEventListener('beforeunload', setCourseId);

        return {
            detail,
            list,
            index
        }
    }
}
</script>

<style lang="scss" scoped>
.rsk-table__td-content-center {
    display: flex;
    height: 100%;
    min-width: 30px;
    align-items: center;
    justify-content: center;
    overflow-wrap: break-word;
    word-break: break-all;
    word-wrap: break-word;
    position: relative;
    min-height: 36px;
    padding: 0 8px;
    font-size: 12px
  }    

.table__td-content {
    color: #30353B;
    height: 100%;
    min-width: 30px;
    overflow-wrap: break-word;
    word-break: break-all;
    word-wrap: break-word;
    position: relative;
    min-height: 36px;
    padding: 0 8px;
    font-size: 12px;
}

.whiteSpace {
    white-space: normal;
}

.select-wrap {
    left: 24px;
    position: relative;
}

.text-wrap {
    width: calc(100% - 24px);
    white-space: normal;
}
</style>
